import cn from 'classnames';
import PropTypes from 'prop-types';
import VerificationInput from 'react-verification-input';

import styles from './CodeInput.module.scss';

export const CodeInput = ({
  className = '',
  autoFocus = true,
  onComplete = () => {},
  onChange = () => {},
  error = false,
  id,
  'aria-label': ariaLabel,
  length = 6,
  dataTestId,
}) => (
  <VerificationInput
    type="number"
    validChars="0-9"
    length={length}
    classNames={{
      container: [className],
      character: [cn(styles.character, { [styles.characterError]: error })],
      characterInactive: [styles.characterInactive],
    }}
    inputProps={{
      autoComplete: 'one-time-code',
      id,
      'aria-label': ariaLabel,
      'data-testid': dataTestId,
    }}
    onComplete={onComplete}
    onChange={onChange}
    autoFocus={autoFocus}
  />
);

CodeInput.propTypes = {
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  onComplete: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  id: PropTypes.string,
  'aria-label': PropTypes.string,
  length: PropTypes.number,
  dataTestId: PropTypes.string,
};
